import "./prism.css";

import React, { Component, RefObject } from 'react';
import { WithStyles, createStyles, withStyles } from '@material-ui/core/styles';

import { Message } from "../../../modules/tracelog";
import Prism from 'prismjs';
import formatter from 'xml-formatter';

const styles = () => createStyles({
    root: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'auto',
    },
    codeBlock: {
        display: 'inline-block',
        textAlign: 'left',
        minHeight: '100%',
    },
})

class PrettyPrintViewer extends Component<Props> {
    contentRef = React.createRef<HTMLElement>();

    componentDidMount () {
        Prism.highlightAll();

        this.props.contentConsumer(this.contentRef);
    }
    
    componentDidUpdate () {
        Prism.highlightAll()
    }
    
    render() {
        const { message, classes } = this.props;

        let body = message.body.replace(/(^|>)(?:\s+)(<|$)/gm, "$1$2")
        
        return (
            <div className={classes.root}>
                <pre className={classes.codeBlock} style={{margin: 0, paddingBottom: '5rem'}}>
                    <code className="language-xml" ref={this.contentRef}>{formatter(body, {collapseContent: true})}</code>
                </pre>
            </div>
        )
    }
}

interface Props extends WithStyles<typeof styles> {
	contentConsumer(ref: RefObject<HTMLElement>): void
	message: Message
}

export default withStyles(styles)(PrettyPrintViewer)